// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"88":"assets/partner-pages/css/app","693":"assets/web/public/css/app","912":"assets/admin/css/app"}[chunkId] + ".css";
};